import {
  ZitchaBanner,
  ZitchaCollectClick,
  ZitchaCollectConversion,
  ZitchaCollectImpression,
  ZitchaCollectPageView,
} from '@as-react/common-types';
import { axiosClient } from '@as-react/common-utils';
import { AxiosRequestConfig } from 'axios';

import { QueryApiOptions, UrlMapping } from '../../types/types';
import { createUrl } from '../../utils/createUrl';

import { zitchaMutationKeys } from './zitcha.mutations';
import { zitchaQueryKeys } from './zitcha.queries';

export type ZitchaBannersParams = {
  location: string;
  placement: string;
};

export type ZitchaCollectParams =
  | ZitchaCollectConversion
  | ZitchaCollectClick
  | ZitchaCollectImpression
  | ZitchaCollectPageView;

const urlMapping: UrlMapping<typeof zitchaQueryKeys & typeof zitchaMutationKeys> = {
  banners: {
    server: 'public/zitcha/search/banners/{mainWebShopId}',
    client: 'api/zitcha/search/banners/{mainWebShopId}',
  },
  analytics: {
    client: 'api/zitcha/collect/{event}/{mainWebShopId}',
  },
};

export const getBanner = async (
  { servicesEndpoint, isServer, defaultRequestParams }: QueryApiOptions,
  { location, placement }: ZitchaBannersParams
): Promise<ZitchaBanner | null> => {
  const requestUrl = createUrl(servicesEndpoint, urlMapping.banners, isServer, {
    mainWebShopId: defaultRequestParams.shopId,
  });

  const axiosConfig: AxiosRequestConfig = {
    method: 'POST',
    url: requestUrl,
    data: {
      location,
      filters: [
        {
          field: 'placement',
          operator: 'EQUAL',
          value: placement,
        },
      ],
      page: 1,
      per_page: 1,
    },
  };

  const result = await axiosClient.request(axiosConfig);

  return Array.isArray(result.data) && result.data.length > 0 ? result.data[0] : null;
};

export const postAnalytics = async (
  { servicesEndpoint, isServer, defaultRequestParams }: QueryApiOptions,
  { event, data }: ZitchaCollectParams
) => {
  const requestUrl = createUrl(servicesEndpoint, urlMapping.analytics, isServer, {
    event,
    mainWebShopId: defaultRequestParams.shopId,
  });

  const axiosConfig: AxiosRequestConfig = {
    method: 'POST',
    url: requestUrl,
    headers: { 'Content-Type': 'application/json' },
    data,
    responseType: 'text',
  };

  await axiosClient.request(axiosConfig);
};
